import { validatePaymentLinkInvalidMock } from '@fixtures/apis/payment/link/validate/validate-payment-link-invalid'
import { validatePaymentLinkValidMock } from '@fixtures/apis/payment/link/validate/validate-payment-link-valid'
import { MockDebug } from '@tino-frontend/mocks'

import { paymentLinkInvoice } from '@fixtures/apis/invoices/supplier-bff'
import { limitReservationsMock } from '@fixtures/apis/limit-reservations/limit-reservations'
import { listMerchantsMock } from '@fixtures/apis/merchant/list-merchants'
import {
  merchantStatusAbleToTransactMock,
  merchantStatusKYCPendingMock,
  merchantStatusLimitBlockedMock,
  merchantStatusLimitPendingMock,
  merchantStatusTermRejectedMock,
  merchantStatusTermRequestedMock,
} from '@fixtures/apis/merchant/merchant-status'
import {
  paymentLinkDetailBilledMock,
  paymentLinkDetailCanceledMock,
  paymentLinkDetailExpiredMock,
  paymentLinkDetailPartialBilledMock,
  paymentLinkDetailPendingNFeMock,
  paymentLinkDetailReservationExpiredMock,
  paymentLinkDetailSentMock,
} from '@fixtures/apis/payment/link'
import { listPaymentLinksMock } from '@fixtures/apis/payment/link/list'
import { REACT_APP_SUPPLIER_BFF_API_URL } from 'constants/envs'
import { paymentLinkDetailRejectedMock } from '@fixtures/apis/payment/link/detail/payment-link-detail-rejected'

// Service: trial
const MockValidatePaymentLink: MockDebug = {
  title: 'Validate Payment Link',
  path: `${REACT_APP_SUPPLIER_BFF_API_URL}/v1/payment-links/validate`,
  method: 'post',
  delay: 2000,
  options: [
    {
      id: 'mock-trial-validate-payment-link-valid',
      title: 'Valid',
      status: 200,
      data: validatePaymentLinkValidMock.source,
    },
    {
      id: 'mock-trial-validate-payment-link-invalid',
      title: 'Invalid',
      status: 200,
      data: validatePaymentLinkInvalidMock.source,
    },
  ],
}

const MockCreatePaymentLink: MockDebug = {
  title: 'Criar link de pagamento',
  path: `${REACT_APP_SUPPLIER_BFF_API_URL}/v1/payment-links`,
  method: 'post',
  delay: 2000,
  options: [
    {
      id: 'mock-trial-create-payment-link-success',
      title: 'Criado com sucesso',
      status: 200,
      data: {
        id: 'd4323074-f700-4065-9b32-3b5b5151ff4a',
        status: '',
        link: 'https://stg.app.tino.com.br/checkout/d4323074-f700-4065-9b32-3b5b5151ff4a',
        supplier_company_id: '0ab0bc59-43db-487c-b0ec-898625a88f92',
        phone_number: '',
        email: 'celtino1@tino.com.br',
        amount_cents: 10000,
        external_id: '1234',
      },
    },
    {
      id: 'mock-trial-create-payment-link-success-without-link',
      title: 'Criado com sucesso (sem link)',
      status: 200,
      data: {},
    },
    {
      id: 'mock-trial-create-payment-link-error',
      title: 'Erro de servidor',
      status: 500,
      data: {},
    },
    {
      id: 'mock-create-payment-link-denied-by-fraud',
      title: 'Negado por fraude (Denied by fraud)',
      status: 403,
      data: {
        error_id: '',
        data: {
          domain: 'payment-link',
          cause: 'denied-by-fraud',
          data: null,
        },
      },
    },
  ],
}

const MockLimitReservations: MockDebug = {
  title: 'Limit Reservations',
  path: `${REACT_APP_SUPPLIER_BFF_API_URL}/v1/limit-reservations`,
  method: 'get',
  delay: 2000,
  options: [
    {
      id: 'mock-trial-limit-reservations-success',
      title: 'Success',
      status: 200,
      data: limitReservationsMock.source,
    },
  ],
}

const MockCancelLimitReservation: MockDebug = {
  title: 'Cancel Limit Reservation',
  path: `${REACT_APP_SUPPLIER_BFF_API_URL}/v1/limit-reservations/:id`,
  method: 'delete' as any,
  delay: 2000,
  options: [
    {
      id: 'mock-trial-cancel-limit-reservation-success',
      title: 'Success',
      status: 200,
      data: {},
    },
    {
      id: 'mock-trial-cancel-limit-reservation-error',
      title: 'Error',
      status: 200,
      data: {},
    },
  ],
}

const MockBillLimitReservation: MockDebug = {
  title: 'Envio de NFe',
  path: `${REACT_APP_SUPPLIER_BFF_API_URL}/v1/limit-reservations/:id/bill`,
  method: 'post',
  delay: 2000,
  options: [
    {
      id: 'mock-send-invoice-success',
      title: 'Envio com sucesso',
      status: 200,
      data: {},
    },
    {
      id: 'mock-send-invoice-incompatible-value',
      title: 'Valor incompatível',
      status: 422,
      data: { error: 'billing amount bigger than reservation' },
    },
    {
      id: 'mock-send-invoice-expired',
      title: 'NF-e expirada',
      status: 422,
      data: { error: 'NFe Submission Date exceeded max days after issue date' },
    },
    {
      id: 'mock-send-invoice-invalid-version',
      title: 'Versão inválida',
      status: 422,
      data: { error: 'NFe Version is invalid' },
    },
    {
      id: 'mock-send-invoice-empty-issue-date',
      title: 'Data de emissão não encontrada',
      status: 422,
      data: { error: 'NFe Issue Date is empty' },
    },
    {
      id: 'mock-send-invoice-empty-id',
      title: 'ID da NF-e não encontrado',
      status: 422,
      data: { error: 'NFe ID is empty' },
    },
    {
      id: 'mock-send-invoice-already-sent',
      title: 'NF-e já enviada',
      status: 422,
      data: { error: 'invoice external_id already exists' },
    },
  ],
}

const MockGetInvoicesLimitReservation: MockDebug = {
  title: 'List Invoices Limit Reservation',
  path: `${REACT_APP_SUPPLIER_BFF_API_URL}/v1/limit-reservations/:id/invoices`,
  method: 'get',
  delay: 2000,
  options: [
    {
      id: 'mock-trial-bill-limit-reservation-success',
      title: 'All status',
      status: 200,
      data: [
        paymentLinkInvoice.build({
          ...paymentLinkInvoice.source,
          status: 'approved',
        }),
        paymentLinkInvoice.build({
          ...paymentLinkInvoice.source,
          status: 'canceled',
        }),
      ],
    },
  ],
}

const MockGetSupplierMerchant: MockDebug = {
  title: 'Informações e Status do Lojista (Supplier)',
  path: `${REACT_APP_SUPPLIER_BFF_API_URL}/v1/suppliers/:supplier_id/merchants/:merchant_document_id`,
  method: 'get',
  delay: 2000,
  options: [
    {
      id: 'mock-merchant-able-to-transact',
      title: 'Crédito disponível',
      status: 200,
      data: merchantStatusAbleToTransactMock.source,
    },
    {
      id: 'mock-merchant-term-requested',
      title: 'Aguardando aceite de termos',
      status: 200,
      data: merchantStatusTermRequestedMock.source,
    },
    {
      id: 'mock-merchant-limit-pending',
      title: 'Crédito em análise',
      status: 200,
      data: merchantStatusLimitPendingMock.source,
    },
    {
      id: 'mock-merchant-kyc-pending',
      title: 'Aguardando validação',
      status: 200,
      data: merchantStatusKYCPendingMock.source,
    },
    {
      id: 'mock-merchant-term-rejected',
      title: 'Termos não aceitos',
      status: 200,
      data: merchantStatusTermRejectedMock.source,
    },
    {
      id: 'mock-merchant-limit-blocked',
      title: 'Negado',
      status: 200,
      data: merchantStatusLimitBlockedMock.source,
    },
  ],
}

const MockGetSalespersonMerchant: MockDebug = {
  title: 'Informações e Status do Lojista (Salesperson)',
  path: `${REACT_APP_SUPPLIER_BFF_API_URL}/v1/salespersons/:supplier_id/merchants/:merchant_document_id`,
  method: 'get',
  delay: 2000,
  options: [
    {
      id: 'mock-merchant-able-to-transact',
      title: 'Crédito disponível',
      status: 200,
      data: merchantStatusAbleToTransactMock.source,
    },
    {
      id: 'mock-merchant-term-requested',
      title: 'Aguardando aceite de termos',
      status: 200,
      data: merchantStatusTermRequestedMock.source,
    },
    {
      id: 'mock-merchant-limit-pending',
      title: 'Crédito em análise',
      status: 200,
      data: merchantStatusLimitPendingMock.source,
    },
    {
      id: 'mock-merchant-kyc-pending',
      title: 'Aguardando validação',
      status: 200,
      data: merchantStatusKYCPendingMock.source,
    },
    {
      id: 'mock-merchant-term-rejected',
      title: 'Termos não aceitos',
      status: 200,
      data: merchantStatusTermRejectedMock.source,
    },
    {
      id: 'mock-merchant-limit-blocked',
      title: 'Negado',
      status: 200,
      data: merchantStatusLimitBlockedMock.source,
    },
  ],
}

const MockListMerchants: MockDebug = {
  title: 'Listagem de Merchants',
  path: `${REACT_APP_SUPPLIER_BFF_API_URL}/v1/merchants`,
  method: 'get',
  delay: 2000,
  options: [
    {
      id: 'mock-all-status',
      title: 'Todos os status',
      status: 200,
      data: listMerchantsMock.source,
    },
  ],
}

const MockPaymentLinkDetail: MockDebug = {
  title: 'Detalhes do Link de Pagamento',
  path: `${REACT_APP_SUPPLIER_BFF_API_URL}/v1/payment-links/:paymentLinkId`,
  method: 'get',
  delay: 2000,
  options: [
    {
      id: 'mock-trial-payment-link-detail-billed',
      title: 'Faturado',
      status: 200,
      data: paymentLinkDetailBilledMock.build(),
    },
    {
      id: 'mock-trial-payment-link-detail-canceled',
      title: 'Cancelado',
      status: 200,
      data: paymentLinkDetailCanceledMock.build(),
    },
    {
      id: 'mock-trial-payment-link-detail-rejected',
      title: 'Cancelado pelo Cliente (Rejected)',
      status: 200,
      data: paymentLinkDetailRejectedMock.build(),
    },
    {
      id: 'mock-trial-payment-link-detail-expired',
      title: 'Expirado',
      status: 200,
      data: paymentLinkDetailExpiredMock.build(),
    },
    {
      id: 'mock-trial-payment-link-detail-sent',
      title: 'Enviado',
      status: 200,
      data: paymentLinkDetailSentMock.build(),
    },
    {
      id: 'mock-trial-payment-link-detail-pending-nfe',
      title: 'Aguardando envio da NF-e',
      status: 200,
      data: paymentLinkDetailPendingNFeMock.build(),
    },
    {
      id: 'mock-trial-payment-link-detail-partial-billed',
      title: 'Parcialmente faturado',
      status: 200,
      data: paymentLinkDetailPartialBilledMock.build(),
    },
    {
      id: 'mock-trial-payment-link-reservation-expired',
      title: 'Reserva expirada',
      status: 200,
      data: paymentLinkDetailReservationExpiredMock.build(),
    },
  ],
}

const MockPaymentLinkList: MockDebug = {
  title: 'Listagem de Links de Pagamento',
  path: `${REACT_APP_SUPPLIER_BFF_API_URL}/v1/payment-links`,
  method: 'get',
  delay: 2000,
  options: [
    {
      id: 'mock-all-status',
      title: 'Todos os status',
      status: 200,
      data: listPaymentLinksMock.source,
    },
  ],
}

const MockConfirmLimitReservation: MockDebug = {
  title: 'Confirm Limit Reservation',
  path: `${REACT_APP_SUPPLIER_BFF_API_URL}/v1/limit-reservations/:limit_reservation_id/confirm`,
  method: 'post',
  delay: 1000,
  options: [
    {
      id: 'mock-confirm-limit-reservation-success',
      title: 'Sucesso',
      status: 200,
      data: {},
    },
    {
      id: 'mock-confirm-limit-reservation-already-canceled',
      title: 'Pedido cancelado',
      status: 422,
      data: { error: 'limit-reservation-confirmation-already-canceled' },
    },
    {
      id: 'mock-confirm-limit-reservation-already-pending',
      title: 'Pedido já concluído',
      status: 422,
      data: { error: 'limit-reservation-confirmation-already-pending' },
    },
    {
      id: 'mock-confirm-limit-reservation-error',
      title: 'Erro de servidor',
      status: 500,
      data: {},
    },
  ],
}

export const MockDebugTrial = [
  MockGetInvoicesLimitReservation,
  MockValidatePaymentLink,
  MockCreatePaymentLink,
  MockLimitReservations,
  MockCancelLimitReservation,
  MockBillLimitReservation,
  MockGetSupplierMerchant,
  MockGetSalespersonMerchant,
  MockListMerchants,
  MockPaymentLinkDetail,
  MockPaymentLinkList,
  MockConfirmLimitReservation,
]
